/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type {ConcreteFragment} from 'relay-runtime';
export type PdpSharedDeposit_item = {|
  +serviceId: ?string;
  +isDepositAvailable: boolean;
|};
*/


const fragment /*: ConcreteFragment*/ = {
  "argumentDefinitions": [
    {
      "kind": "RootArgument",
      "name": "userId",
      "type": "String"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedDeposit_item",
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "args": null,
      "name": "serviceId",
      "storageKey": null
    },
    {
      "kind": "ScalarField",
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "buyerId",
          "variableName": "userId",
          "type": "String"
        }
      ],
      "name": "isDepositAvailable",
      "storageKey": null
    }
  ],
  "type": "Item"
};

module.exports = fragment;
